/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line import/no-unresolved
import {
  format, compareAsc, parseISO,
} from 'date-fns';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import {
  Icon, UiTable, Slider,
  UiColumn,
  HtmlContentLoader,
  Link,
  ParallaxScroll,
} from '@powdr/components';
import { Components, DorMeasurementFieldNames, VerticalPosition } from '@powdr/constants';
import { AppContext } from '@powdr/context';
import { usePlaceStatus } from '@powdr/hooks';
import {
  textFilter,
  cleanSliderData, cleanTableData,
  capitalizeAllWords,
  deslugify,
} from '@powdr/utils';

import {
  StyledTemplatedContent, NewsStyleDate,
  DynamicTitle, DynamicBody, NewsStyleImage,
  StartEndDate, DateContainer, RowSection,
  ContentContainer, SplitContentContainer,
  LocationHoursContainer, DynamicContactInfo,
  ContactInfoSection, DynamicHours, DynamicMenu,
  DynamicPrice,
  DynamicBodySplit,
  MaxWidthWrapper,
  InnerWrapper,
  LocationSection,
  DropdownsWrapper,
  DropdownsWrapperHeader,
  Dropdowns,
  DynamicSubheader,
  StatusSection,
  StatusContent,
  StatusHeader,
  TagList,
  Tag,
  TableWrapper,
  TableDetails,
} from './styles';

export const TemplatedContent = ({
  fields,
  isParentModal = true,
}) => {
  const { themeConfig: { modal } } = useContext(AppContext);
  const {
    title, body: bodyContent,
    field_date: dateString, field_end_date: endDateString, field_datestamp: datestampString,
    field_ui_table: tableContent, field_slider: sliderAPI, field_image: image,
    field_author: author, field_contact_name: contactName,
    field_contact_email: contactEmail, field_contact_phone: contactPhone,
    field_hours: hours, field_menu: menu, field_price_range: priceRange,
    field_location: location, field_location_details: locationDetails,
    field_phone_number: phoneNumber, field_phone_number_details: phoneNumberDetails,
    field_subheader: subheader, field_dynamic_status: status,
    additionalContent, columnContent, sidebarContent, relationships: components, dropdownsHeader,
    tags, isShowTags, field_venue: venue,
    enableParallaxScroll, tableDetails,
  } = fields;
  const body = (bodyContent?.value) ? bodyContent.value : bodyContent;
  const slider = (components?.slider) ? components.slider : sliderAPI;
  const table = (tableContent?.rows) ? tableContent.rows : tableContent;
  const dropdowns = components?.dropdowns;
  const upperDropdowns = components?.upperDropdowns;
  const hoursContent = (hours?.value) ? hours.value : (hours && typeof hours === 'string') ? `<p>${hours}</p>` : null;
  const columnGallery = components?.columnGallery;

  const startDate = (dateString || datestampString)
    ? parseISO(dateString || datestampString).setHours(0, 0, 0, 0)
    : null;
  const endDate = (endDateString) ? parseISO(endDateString).setHours(0, 0, 0, 0) : null;
  const newsStyleModal = false;
  const isSplitContent = (slider || sidebarContent?.value);
  const statusValue = usePlaceStatus(status?.uuid || null)?.[DorMeasurementFieldNames.STATUS];

  return (
    <StyledTemplatedContent
      className="templated-content-main"
      $splitContent={isSplitContent}
      $isParentModal={isParentModal}
    >
      <InnerWrapper>
        <MaxWidthWrapper>
          {(title || body || table || slider) && (
            <RowSection>
              <ContentContainer $splitContent={isSplitContent}>
                {(startDate && newsStyleModal) && <NewsStyleDate>{format(startDate, 'MMMM d, yyyy')}</NewsStyleDate>}
                {(title) && <DynamicTitle>{textFilter(title)}</DynamicTitle>}
                {(subheader) && (
                  <DynamicSubheader>
                    {textFilter(subheader)}
                  </DynamicSubheader>
                )}
                {(image && newsStyleModal) && <NewsStyleImage />}
                {((startDate || endDate) && !newsStyleModal) && (
                <DateContainer>
                  <Icon name="content-calendar" width="25" height="25" />
                  <StartEndDate>
                    {`${format(startDate, 'MMMM d, yyyy')}`}
                    {(endDate && compareAsc(startDate, endDate) !== 0) ? ` - ${format(endDate, 'MMMM d, yyyy')}` : ''}
                  </StartEndDate>
                </DateContainer>
                )}
                {(venue && venue !== '') && (
                  <DateContainer>
                    <Icon name="content-pin-hollow" width="25" height="25" />
                    <StartEndDate>
                      {venue}
                    </StartEndDate>
                  </DateContainer>
                )}
                {((location && location !== '') || (phoneNumber && phoneNumber !== '') || hoursContent || (venue && venue !== '')) && (
                <LocationHoursContainer>
                  {(hoursContent) && (
                  <DynamicHours component={Components.MODAL}>
                    {(priceRange) && <DynamicPrice max={4} value={priceRange} character="$" />}
                    <HtmlContentLoader html={hoursContent} />
                  </DynamicHours>
                  )}
                  {(location !== '' || phoneNumber !== '' || statusValue) && (
                  <DynamicContactInfo>
                    {(statusValue) && (
                    <StatusSection component={Components.MODAL}>
                      <StatusHeader className="bold">Status</StatusHeader>
                      <StatusContent $status={statusValue}>
                        {capitalizeAllWords(deslugify(statusValue))}
                      </StatusContent>
                    </StatusSection>
                    )}
                    <LocationSection>
                      {(location && location !== '') && <small className="bold">{location}</small>}
                      {(locationDetails && locationDetails !== '') && <small className="bold">{`${locationDetails}`}</small>}
                    </LocationSection>
                    <ContactInfoSection>
                      {(phoneNumber && phoneNumber !== '') && <small><Link href={`tel:${phoneNumber}`}>{phoneNumber}</Link></small>}
                      {(phoneNumberDetails && phoneNumberDetails !== '') && <small>{`${phoneNumberDetails}`}</small>}
                    </ContactInfoSection>
                  </DynamicContactInfo>
                  )}
                </LocationHoursContainer>
                )}
                {(body) && (
                  <>
                    {enableParallaxScroll && <ParallaxScroll />}
                    <DynamicBody
                      component={Components.MODAL}
                      $parallaxEnabled={enableParallaxScroll}
                    >
                      <HtmlContentLoader html={body} />
                    </DynamicBody>
                  </>
                )}
                {(upperDropdowns?.relationships) && (
                  <DropdownsWrapper>
                    <Dropdowns
                      parentColorProfile={modal}
                      relationships={upperDropdowns.relationships}
                    />
                  </DropdownsWrapper>
                )}
                {(sidebarContent?.value) && (
                  <DynamicBodySplit className="mobile-sidebar-content">
                    <HtmlContentLoader html={sidebarContent.value} />
                  </DynamicBodySplit>
                )}
                {(menu?.value) && (
                  <DynamicMenu component={Components.MODAL}>
                    <HtmlContentLoader html={menu.value} />
                  </DynamicMenu>
                )}
                {(author) && <p>{author}</p>}
                {(contactName) && <p>{contactName}</p>}
                {(contactEmail) && <p>{contactEmail}</p>}
                {(contactPhone) && <p>{contactPhone}</p>}
              </ContentContainer>
              {(slider || sidebarContent || (tags && isShowTags)) && (
                <SplitContentContainer>
                  {(slider) && (
                    <Slider {...cleanSliderData(slider)} parentColorProfile={modal} />
                  )}
                  {(sidebarContent?.value) && (
                    <DynamicBodySplit className="desktop-sidebar-content" component={Components.MODAL}>
                      <HtmlContentLoader html={sidebarContent.value} />
                    </DynamicBodySplit>
                  )}
                  {(tags && isShowTags) && (
                    <TagList>
                      {tags.map((t) => <Tag>{t}</Tag>)}
                    </TagList>
                  )}
                </SplitContentContainer>
              )}
            </RowSection>
          )}
          {(table && Object?.values(table)?.filter((x) => x)?.length > 0) && (
            <TableWrapper>
              <UiTable
                tables={[{ rows: cleanTableData(table) }]}
                parentColorProfile={modal}
              />
              {tableDetails?.value && (
                <TableDetails component={Components.MODAL}>
                  <HtmlContentLoader html={tableDetails.value} />
                </TableDetails>
              )}
            </TableWrapper>
          )}
          {(additionalContent?.value) && (
            <DynamicBody component={Components.MODAL}>
              <HtmlContentLoader html={additionalContent.value} />
            </DynamicBody>
          )}
          {(columnContent?.value && columnGallery) && (
            <UiColumn
              relationships={{
                columnComponents: [
                  columnGallery,
                  {
                    id: Math.random(),
                    typeName: Components.UI_HTML,
                    html: { value: columnContent?.value },
                  },
                ],
              }}
              contentPosition={VerticalPosition.MIDDLE}
            />
          )}
          {(dropdowns?.relationships) && (
            <DropdownsWrapper>
              {(dropdownsHeader && dropdownsHeader !== '') && (
                <DropdownsWrapperHeader>
                  {dropdownsHeader}
                </DropdownsWrapperHeader>
              )}
              <Dropdowns
                parentColorProfile={modal}
                relationships={dropdowns.relationships}
              />
            </DropdownsWrapper>
          )}
        </MaxWidthWrapper>
      </InnerWrapper>
    </StyledTemplatedContent>
  );
};

TemplatedContent.propTypes = {
  fields: PropTypes.shape().isRequired,
  isParentModal: PropTypes.bool,
};
